import CryptoJS from 'crypto-js';

// The key must match the backend EXACTLY.
// Backend pads right with '0' to reach 32 characters.
const rawKey = "4*u@tNLZ%3X5r#*ttWBfF$zFb";
const paddedKey = rawKey.padEnd(32, '0').substring(0, 32);

export function encryptPassword(password: string): string {
  if (!password) return '';
  const keyHex = CryptoJS.enc.Utf8.parse(paddedKey);
  const encrypted = CryptoJS.AES.encrypt(password, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
